import { Button, Modal } from "components"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { ListWarehouse } from "../types"

export function DeleteModal({ data, toggle, refetch }: { data: ListWarehouse; toggle: () => void; refetch: () => void }) {
  const api = useApi()

  const onDelete = () => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(`/location-warehouse/delete?location_warehouse_id=${data.location_warehouse_id}`),
        { loading: "Loading...", success: (res) => res.data.message, error: (err) => err.response.data.message }
      ).then(() => { toggle(); refetch() }).catch(() => {}).finally(resolve)
    })
  }

  return (
    <Modal isOpen title="DELETE WAREHOUSE" closeModal={toggle}>
      <Modal.Body>
        <h5 className="text-error">Are you sure want to delete this data?</h5>
        <p className="mt-2"><span className="font-bold">{data.warehouse_code}</span> — {data.warehouse_name}</p>
      </Modal.Body>
      <Modal.Footer className="text-end">
        <Button color="error" onClick={onDelete}>Delete</Button>
      </Modal.Footer>
    </Modal>
  )
}
